import { type ComponentType, type LazyExoticComponent, lazy } from "react"

import { type TParticipantHeaderEntityProps } from "./participant.header.entity"

const ParticipantHeaderEntity: LazyExoticComponent<ComponentType<TParticipantHeaderEntityProps>> = lazy(
    (): Promise<{ default: ComponentType<TParticipantHeaderEntityProps> }> =>
        import("./participant.header.entity").then(
            ({ ParticipantHeaderEntity: E }): { default: ComponentType<TParticipantHeaderEntityProps> } => ({
                default: E
            })
        )
)

export { ParticipantHeaderEntity, type TParticipantHeaderEntityProps }
export {
    EParticipantHeaderVariant,
    EParticipantHeaderComponentName,
    EParticipantHeaderComponentLayout,
    type TParticipantHeaderComponentRenderProps,
    type TModuleExcerptModelToRender
} from "./ui/participant.header.ui.types"
export { EParticipantHeaderQueryKey } from "./api"
export {
    useParticipantHeaderDispatcher,
    type TParticipantHeaderDispatcher,
    useParticipantHeaderSelector,
    participantHeaderReducer,
    PARTICIPANT_HEADER_REDUCER_NAME,
    type IParticipantHeaderState
} from "./store"
export { useModulesExcerptsScrollEffects } from "./hooks"
